import _ from 'lodash';
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';

//- Material UI / Style
import { withStyles } from '@material-ui/core/styles';
//containers
import AuthUserContainer from '../../containers/AuthUser';
//- UI / Form
import FormSelect from '../../components/form/FormSelect';
import FormActions from '../../components/form/FormActions';
import FormContainer from '../../components/FormContainer';
import TimeClockPermissionContainer from '../../containers/TimeClock/TimeClockPermission';
import UserPicker from '../../components/advancedForm/UserPicker';
import SectionHeader from '../../components/SectionHeader';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/Button';
import DeleteIcon from '@material-ui/icons/Delete';
import Button from '@material-ui/core/Button';
import LocationSelect from '../../components/advancedForm/LocationSelect';

const styles = () => {
	return {
		deleteButton: {
			verticalAlign: 'middle',
			padding: '8px 10px',
		},
		addGroupButton: {
			borderRadius: '100px',
			fontSize: 16,
		},
		groupContainer: {
			borderLeft: '4px solid #ddd',
			marginLeft: 10,
			paddingLeft: 5,
			marginBottom: 20,
		},
	};
};

class TimeClockPermissionSave extends Component {
	constructor(props) {
		super(props);

		const action = _.get(this.props, 'match.params.action');
		const timeClockPermissionId = parseInt(
			_.get(this.props, 'match.params.timeClockPermissionId'),
			10
		);
		const isUpdate = action === 'update';

		this.state = {
			isUpdate,
			timeClockPermissionId,
			formFieldError: {},
			canViewRules: [],
			canModifyRules: [],
		};
	}

	componentDidMount() {
		const { timeClockPermission, getTimeClockPermission } = this.props;
		const { timeClockPermissionId, isUpdate } = this.state;

		if (!isUpdate) {
			return;
		}

		if (timeClockPermission) {
			this.fillForm();
		} else {
			getTimeClockPermission({
				params: { timeClockPermissionIds: [timeClockPermissionId] },
			});
		}
	}

	componentDidUpdate(prevProps, prevState, snapShot) {
		const { timeClockPermission } = this.props;

		if (_.isUndefined(prevProps.timeClockPermission) && !_.isUndefined(timeClockPermission)) {
			this.fillForm();
		}
	}

	fillForm = () => {
		const { timeClockPermission } = this.props;
		const { isUpdate } = this.state;
		if (!isUpdate && timeClockPermission) {
			return;
		}

		const { supervisorUserId, canViewRules, canModifyRules } = timeClockPermission;

		canViewRules.concat(canModifyRules).forEach((rule) => {
			const { forEveryone, forLocationId, forUserId } = rule;
			if (forEveryone) {
				rule.groupType = 'forEveryone';
			} else if (forLocationId) {
				rule.groupType = 'forLocationId';
			} else if (forUserId) {
				rule.groupType = 'forUserId';
			}
		});

		this.setState({
			supervisorUserId,
			canViewRules,
			canModifyRules,
		});
	};

	//- Path is always a string
	//- value is never an event (value.target)
	onChange = (value, path) => {
		const arrayPath = _.toPath(path);
		const basePath = _.head(arrayPath);
		let base = this.state[basePath];
		let newState = {};

		if (_.isArray(base) || _.isObject(base)) {
			base = _.cloneDeep(base);
			_.set(base, arrayPath.slice(1), value);
			newState[basePath] = base;
		} else {
			newState[basePath] = value;
		}

		//- Clear any errors on the path
		let formFieldError = Object.assign({}, this.state.formFieldError);
		delete formFieldError[path];
		newState.formFieldError = formFieldError;

		this.setState(newState);
	};

	goBackToList = () => {
		this.props.history.push(`/timeClockPermission/list`);
	};

	handleSave = ({ callback }) => {
		const { addTimeClockPermission, updateTimeClockPermission, showErrors } = this.props;

		const { isUpdate, timeClockPermissionId } = this.state;

		const formFieldError = {};

		const requiredFields = [{ path: 'supervisorUserId', label: 'Supervisor' }];

		requiredFields.forEach(({ path, label }) => {
			if (!this.state[path]) {
				formFieldError[path] = `${label} is required`;
			}
		});

		//- Get all the values and do individual checks
		if (_.keys(formFieldError).length) {
			this.setState({ formFieldError });
			showErrors(_.values(formFieldError));
			return;
		}

		const { supervisorUserId, canViewRules, canModifyRules } = this.state;

		const canViewRulesParam = [];
		canViewRules.forEach((rule) => {
			const { forUserId, forLocationId, groupType } = rule;
			if (groupType === 'forEveryone') {
				canViewRulesParam.push({ forEveryone: true });
			} else if (forUserId) {
				canViewRulesParam.push({ forUserId });
			} else if (forLocationId) {
				canViewRulesParam.push({ forLocationId });
			}
		});

		const canModifyRulesParam = [];
		canModifyRules.forEach((rule) => {
			const { forUserId, forLocationId, groupType } = rule;
			if (groupType === 'forEveryone') {
				canModifyRulesParam.push({ forEveryone: true });
			} else if (forUserId) {
				canModifyRulesParam.push({ forUserId });
			} else if (forLocationId) {
				canModifyRulesParam.push({ forLocationId });
			}
		});

		const params = {
			supervisorUserId,
			canViewRules: canViewRulesParam,
			canModifyRules: canModifyRulesParam,
		};

		if (!isUpdate) {
			addTimeClockPermission({
				params,
				callback,
			});
		} else {
			params.timeClockPermissionId = timeClockPermissionId;
			updateTimeClockPermission({
				params,
				callback,
			});
		}
	};

	getInputProps = (path, defaultValue) => {
		return {
			key: path,
			path,
			value: this.getValue(path, defaultValue),
			checked: this.getValue(path, defaultValue),
			error: this.getError(path),
			onChange: this.onChange,
			gridProps: { md: 12 },
		};
	};

	getValue = (path, defaultValue) => {
		const _d = _.isUndefined(defaultValue) ? '' : defaultValue;
		return _.get(this.state, path, _d);
	};

	getError = (path) => {
		return _.get(this.state.formFieldError, path);
	};

	addRule = ({ ruleName }) => {
		this.setState({
			[ruleName]: this.state[ruleName].concat([
				{
					bolNumberToInvoiceIdHash: {},
					carrierPoNumberToInvoiceIdHash: {},
					vendorBillOrderLineItems: [{}],
				},
			]),
		});
	};

	removeRule = ({ ruleName, index }) => {
		const inputs = this.state[ruleName].slice();
		inputs.splice(index, 1);
		this.setState({ [ruleName]: inputs });
	};

	render() {
		const { isUpdate } = this.state;
		const { showErrors } = this.props;

		const action = isUpdate ? 'Update' : 'Add';
		return (
			<FormContainer headline={`${action} Supervisor Permission`}>
				<UserPicker
					label="Supervisor"
					{...this.getInputProps('supervisorUserId')}
					whoToShow={'nonDriversOnly'}
				/>

				<SectionHeader label={'Can View Time Clock / Schedule For'} gridProps={{ md: 12 }} />
				{this.renderRules({ ruleName: 'canViewRules', display: 'view' })}

				<SectionHeader label={'Can Modify Time Clock / Schedule For'} gridProps={{ md: 12 }} />
				{this.renderRules({ ruleName: 'canModifyRules', display: 'modify' })}

				<FormActions
					onSave={this.handleSave}
					onCancel={this.goBackToList}
					onDone={this.goBackToList}
					onError={showErrors}
					saveButtonText={`${action} Supervisor Permissions`}
					saveProgressText={
						isUpdate ? 'Updating supervisor permissions' : 'Creating new permissions'
					}
					saveSuccessText={'Supervisor permissions saved successfully. Thank you.'}
				/>
			</FormContainer>
		);
	}

	renderRules = ({ ruleName, display }) => {
		const { classes } = this.props;
		const rules = this.state[ruleName];

		return (
			<Fragment>
				{rules.map((row, index) => {
					const prefix = `${ruleName}.${index}`;
					return (
						<Grid container spacing={1} className={classes.groupContainer} key={prefix}>
							<Grid item xs={11}>
								<Grid container spacing={1}>
									<FormSelect
										{...this.getInputProps(`${prefix}.groupType`)}
										label={'Select your permission type'}
										gridProps={{ md: 12 }}
										options={[
											{ value: 'forEveryone', display: 'Entire Company' },
											{ value: 'forLocationId', display: 'All drivers at terminal' },
											{ value: 'forUserId', display: 'Individual employee' },
										]}
									/>

									{row.groupType === 'forUserId' && (
										<UserPicker
											label="Subordinate"
											{...this.getInputProps(`${prefix}.forUserId`)}
										/>
									)}

									{row.groupType === 'forLocationId' && (
										<LocationSelect
											label="All drivers assigned to terminal"
											{...this.getInputProps(`${prefix}.forLocationId`)}
										/>
									)}
								</Grid>
							</Grid>

							<Grid item xs={1}>
								<IconButton
									color="primary"
									className={classes.deleteButton}
									onClick={() => this.removeRule({ ruleName, index })}
								>
									<DeleteIcon />
								</IconButton>
							</Grid>
						</Grid>
					);
				})}

				<Grid item xs={12}>
					<Button
						variant="contained"
						className={classes.addGroupButton}
						onClick={() => this.addRule({ ruleName })}
					>
						add another {display} permission
					</Button>
				</Grid>
			</Fragment>
		);
	};
}

TimeClockPermissionSave.propTypes = {
	getTimeClockPermission: PropTypes.func.isRequired,
	addTimeClockPermission: PropTypes.func.isRequired,
	updateTimeClockPermission: PropTypes.func.isRequired,
	timeClockPermission: PropTypes.object,

	showErrors: PropTypes.func.isRequired,
	classes: PropTypes.object.isRequired,
};

export default _.flow([withStyles(styles), AuthUserContainer, TimeClockPermissionContainer])(
	TimeClockPermissionSave
);
